// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const connectorsClient = createTypedClient();
export const createConnectorsClient = (config) => createTypedClient(config);
